import {isString} from 'lodash'
import {Moment} from 'moment-timezone'

import {DateRange, Iso8601, Shift, ShiftQuickSelectSlots, TimeRange} from '../types'

import {getQuickSelectFilter} from './filterParameter.utils'

export const toTimeRange = ([startDate, endDate]: [start: Moment, end: Moment]): TimeRange => ({
  startDate: startDate.toISOString(),
  endDate: endDate.toISOString()
})
export const toDateRange = ([startDate, endDate]: [start: Moment, end: Moment]): DateRange => ({
  startDate,
  endDate
})

export const queryRangeToTimeRange = (
  queryRange: DateRange | ShiftQuickSelectSlots,
  shifts: Shift[],
  currentTime: Moment
): {startDate?: Iso8601; endDate?: Iso8601} => {
  if (isString(queryRange)) {
    const [startDate, endDate] = getQuickSelectFilter(queryRange, shifts, currentTime)
    return {startDate: startDate?.toISOString(), endDate: endDate?.toISOString()}
  }
  return toTimeRange([queryRange.startDate, queryRange.endDate])
}
